import { StyleSheet } from "../StyleSheet";
import { Button, Typography } from "antd";
import { useSelector } from "react-redux";
import { getAlertImageData } from "../stores/slices/alertImageSlice";
import MarkdownPreviewer from "../common/MarkdownPreviewer";
import { Link } from "react-router-dom";
const { Text } = Typography;

const AlertModalImage = () => {
    const {
        show, onPressBtnPrimary, onPressBtnSecondary, popupData
    } = useSelector(getAlertImageData);

    return (
        <>
            {
                show && popupData ?
                    <div style={styles.mainContainer}>
                        <div style={styles.cardContainer}>
                            <Text style={styles.headerContainer}>
                                {popupData.title}
                            </Text>
                            <div>
                                <img src={popupData.url_image} alt={"popupImage"} style={styles.image} />
                            </div>
                            <div style={styles.bodyContainer}>
                                <div style={{ marginTop: 15 }}>
                                    {
                                        popupData.link ?
                                            <Link
                                                to={popupData.link}
                                                target='_blank'
                                            >
                                                <MarkdownPreviewer
                                                    h1Style={{ ...styles.titleStyle, ...{ fontSize: 16, color: "#000000" } }}
                                                    h2Style={styles.titleStyle}
                                                    h3Style={styles.titleStyle}
                                                    textStyle={styles.textStyle}
                                                    mdSource={popupData.details}
                                                />
                                            </Link>
                                            :
                                            <MarkdownPreviewer
                                                h1Style={{ ...styles.titleStyle, ...{ fontSize: 16, color: "#000000" } }}
                                                h2Style={styles.titleStyle}
                                                h3Style={styles.titleStyle}
                                                textStyle={styles.textStyle}
                                                mdSource={popupData.details}
                                            />
                                    }
                                </div>
                                {
                                    onPressBtnPrimary && onPressBtnSecondary ?
                                        <div style={styles.buttonContainer}>
                                            <Button style={styles.buttonStyle} onClick={() => onPressBtnPrimary()}>Aceptar</Button>
                                            <Button style={styles.buttonStyle} onClick={() => onPressBtnSecondary()}>Cancelar</Button>
                                        </div>
                                        : null
                                }
                            </div>
                        </div>

                    </div>
                    : null
            }
        </>
    );
};



//-------------------------------------------------------------------------------------------------- Styles
const styles = StyleSheet.create({
    mainContainer: {
        position: "absolute",
        display: "flex",
        width: "100%",
        height: "100%",
        zIndex: 100,
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
    },
    image: {
        width: '100%',
        color: "black",
    },
    cardContainer: {
        width: 450,
        borderRadius: "15px",
    },
    headerContainer: {
        display: "flex",
        width: "100%",
        height: 80,
        borderRadius: "15px 15px 0px 0px",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: 'white',
        fontSize: 20,
        fontWeight: 600,
        color: "#083f94"
    },
    bodyContainer: {
        display: "flex",
        flexDirection: 'column',
        width: "100%",
        borderRadius: "0px 0px 15px 15px",
        alignItems: "center",
        backgroundColor: 'white',
    },
    buttonStyle: {
        fontSize: 16,
        fontWeight: 600,
        border: "none",
        color: "#1f3692",
        backgroundColor: "transparent",
        boxShadow: "none"
    },
    buttonContainer: {
        justifyContent: 'space-evenly',
        display: 'flex',
        width: "100%",
        padding: 15
    },
    textStyle: {
        fontSize: 14,
        margin: 0,
        color: "#707070",
    },
    titleStyle: {
        fontSize: 14,
        margin: 0,
        color: "#707070",
        fontWeight: 500
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export default AlertModalImage;
